import a from "react";
import { getIconColor as p } from "./iconfont.es5470.js";
import E from "./iconfont.es5471.js";
const r = {
  display: "block"
}, f = ({ size: t = 16, useVw: l, useRem: n, color: o, withColor: i, removeClassName: e, disableSSR: m, style: c, ...d }) => {
  const x = c ? { ...r, ...c } : r;
  return /* @__PURE__ */ a.createElement(E, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-CEXminiapp", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: l ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (n ? "rem" : "px"), height: l ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (n ? "rem" : "px"), className: e ? "" : "iconpark-icon", style: x, fill: "none", ...d }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: e ? "" : "32px-CEXminiapp"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: e ? "" : "normal",
        fill: i ? p(o, 0, "#262933") : "#262933",
        datafollowfill: i ? p(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M4 6.59A3.59 3.59 0 0 1 7.59 3h13.82A3.59 3.59 0 0 1 25 6.59V14a1 1 0 1 1-2 0V6.59A1.59 1.59 0 0 0 21.41 5H7.59A1.59 1.59 0 0 0 6 6.59v17.32c0 .878.712 1.59 1.59 1.59H12a1 1 0 1 1 0 2H7.59A3.59 3.59 0 0 1 4 23.91V6.59Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M9.85 9.3a1 1 0 0 1 1-1h7.273a1 1 0 1 1 0 2H10.85a1 1 0 0 1-1-1Zm8.548 14.923a.85.85 0 0 0 .953-.302l-.002.022L19.043 27a.85.85 0 0 0 1.447.685l1.312-1.312 3.077 2.308a.85.85 0 0 0 1.34-.496l2.238-10.07a1.35 1.35 0 0 0-1.825-1.545l-11.95 4.838a.85.85 0 0 0 .05 1.594l3.666 1.222Zm-.942-2.106 9.197-3.722-1.808 8.134-2.613-1.96a.85.85 0 0 0-1.11.08l-.15.15.033-.33 4.304-3.444a.85.85 0 0 0-1.062-1.328l-4.584 3.667a.849.849 0 0 0-.153.16.85.85 0 0 0-.575-.914l-1.479-.493Z"
        }
      )
    )
  )));
}, A = f;
export {
  A as default
};
